<template>
  <div class="mp-container">
    <div class="mp-root-view">
      <div class="mp-title">
        <span class="title">设置密码</span>
        <img @click="toggleShowModifyPasswordView(0)" class="icon" src="../../../static/img/user/icon_szmm_gb.png">
      </div>
      <div class="input-view">
        <span class="input-title">当前密码</span>
        <input v-model="oldPassword" @keydown.enter="toggleShowModifyPasswordView(1)" class="input" autofocus type="password">
      </div>
      <div class="input-view">
        <span class="input-title">密码</span>
        <input v-model="newPassword" @keydown.enter="toggleShowModifyPasswordView(1)" class="input" type="password">
      </div>
      <div class="input-view">
        <span class="input-title">确认密码</span>
        <input v-model="confirmPassword" @keydown.enter="toggleShowModifyPasswordView(1)" class="input" type="password">
      </div>
      <div class="btn-view">
        <span @click="toggleShowModifyPasswordView(1)" :class="{modify: this.isModify}" class="confirm-btn">{{ this.isModify ? '修改中...' : '确认' }}</span>
        <span @click="toggleShowModifyPasswordView(0)" class="cancel-btn">取消</span>
      </div>
    </div>
  </div>
</template>

<script>
import { Base64 } from 'js-base64'
import MyCookies from '@/utils/my_cookies'

export default {
  name: 'ModifyPassword',
  data () {
    return {
      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      isModify: false
    }
  },
  methods: {
    /**
     * 显示隐藏修改密码框,key用来区分确认或者取消
     */
    toggleShowModifyPasswordView (key) {
      switch (key) {
        case 1:
          if (this.oldPassword === '' || this.newPassword === '' || this.confirmPassword === '') {
            this.$store.commit('show_alert', '请填写完整信息')
            return
          } else if (this.newPassword !== this.confirmPassword) {
            this.$store.commit('show_alert', '新密码和确认密码不一致')
            return
          }
          if (this.newPassword.length < 6) {
            this.$store.commit('show_alert', '密码长度不得小于6位！')
            return
          }
          this.modifyPassword()
          break
        case 0:
          this.$store.commit('toggle_show_modify_password_view')
          // 清空输入信息
          this.oldPassword = ''
          this.newPassword = ''
          this.confirmPassword = ''
          break
      }
    },
    /**
     * 修改密码
     */
    modifyPassword () {
      this.isModify = true
      let params = {
        flag: 'change_password',
        new_password: Base64.encode(this.newPassword),
        old_password: Base64.encode(this.oldPassword),
        user_id: this.$store.state.user_info.id
      }
      // 请求数据
      this.APIS.MODIFY_PASSWORD(params)
      .then((res) => {
        this.isModify = false
        switch (res.data.status) {
          case 0:
            this.$store.commit('show_alert', '密码修改成功')
            this.$store.commit('toggle_show_modify_password_view')
            // 清空输入信息
            this.oldPassword = ''
            this.newPassword = ''
            this.confirmPassword = ''
            // 清除用户cookie信息
            MyCookies.setCookie('username', '', -1, '/')
            MyCookies.setCookie('password', '', -1, '/')
            // 跳转到登陆界面
            this.$router.push('/p/login')
            break
          case 1:
            this.$store.commit('show_alert', '原密码错误')
            break
        }
      })
      .catch((err) => {
        this.$store.commit('show_alert', '密码未修改成功')
      })
    },
  }
}
</script>

<style lang="less" scoped>
:-webkit-autofill,
:-webkit-autofill:hover,
:-webkit-autofill:focus {
  border: none;
          box-shadow: 0 0 0px 1000px white inset;
  -webkit-box-shadow: 0 0 0px 1000px white inset;
  transition: background-color 5000s ease-in-out 0s;
}
.mp-container {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba( 0, 0, 0, .5);
  z-index: 1001;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .mp-root-view {
    width: 485px;
    height: 310px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #ffffff;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    .mp-title {
      width: 100%;
      height: 50px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      background-color: #f7f7f7;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      .title {
        font-size: 18px;
        color: #333333;
        margin-left: 15px;
      }
      .icon {
        width: 24px;
        height: 24px;
        margin-right: 15px;
        cursor: pointer;
      }
    }
    .input-view {
      width: 280px;
      height: 36px;
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-top: 20px;
      .input-title {
        width: 64px;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        font-size: 16px;
        color: #333333;
      }
      .input {
        width: 180px;
        height: 100%;;
        background-color: #ffffff;
        border-radius: 2px;
        margin-left: 20px;
        padding-left: 5px;
        border: solid 1px #e0e0e0;
      }
    }
    .btn-view {
      width: 280px;
      height: 40px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-top: 25px;
      .confirm-btn, .cancel-btn {
        width: 120px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 20px;
        font-size: 16px;
        cursor: pointer;
      }
      .modify {
        background-color: #f08710;
      }
      .confirm-btn {
        color: #ffffff;
        background-color: #ff9a28;
      }
      .confirm-btn:hover {
        background-color: #f08710;
      }
      .cancel-btn {
        color: #999999;
        border: solid 1px #e0e0e0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/user/modify_password.vue